// Soft language swap: fetches the chosen locale's version of this page and replaces <body> without a full reload.
class LanguageToggle extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.addEventListener('submit', (event) => this.handleSubmit(event), { signal: this.controller.signal });
    window.addEventListener('popstate', () => window.location.reload(), { signal: this.controller.signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async handleSubmit(event) {
    const submitter = event.submitter;
    const targetUrl = submitter?.dataset.url;
    if (!targetUrl) return;
    event.preventDefault();
    if (submitter.getAttribute('aria-pressed') === 'true') return;

    const form = event.target;
    const formData = new FormData(form, submitter);

    try {
      const response = await fetch(targetUrl, { headers: { Accept: 'text/html' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Language fetch failed: ${response.status}`);
      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');

      // Persist the buyer's choice (locale cookie) the same way the native form would.
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' }).catch(() => {});

      const swap = () => {
        document.documentElement.lang = nextDocument.documentElement.lang;
        document.title = nextDocument.title;
        document.body.className = nextDocument.body.className;
        document.body.replaceChildren(...nextDocument.body.childNodes);
        history.pushState({ language: submitter.value }, '', targetUrl);
      };

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (document.startViewTransition && !reduceMotion) {
        document.startViewTransition(swap);
      } else {
        swap();
      }
    } catch (error) {
      window.location.assign(targetUrl);
    }
  }
}

if (!customElements.get('s-language-toggle')) {
  customElements.define('s-language-toggle', LanguageToggle);
}
